import { Provider } from 'mobx-react';
import * as React from 'react';
import { merge, Store as Store$1, BERNIE_CORE_EVENTS, getExperimentLogger } from 'bernie-core';
import { toJS, runInAction, observable, computed, action } from 'mobx';
import { PlatformAnalyticsStore, trackEvent } from 'bernie-analytics';
import { SystemEvent, SystemEventLevel, NOOP_LOGGER } from 'bernie-logger';
import { getBexApiContext } from 'bernie-context';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var Store = /** @class */ (function (_super) {
    __extends(Store, _super);
    /**
     * Constructs a new `Store`.
     *
     * @param state Serialized state JSON.
     * @param logger Bernie logger
     */
    function Store(state, logger) {
        if (state === void 0) { state = {}; }
        return _super.call(this, state, logger, runInAction) || this;
    }
    /**
     * Creates a basic JSON object from the store, excluding
     * any fields provided in `excludedFields`.
     */
    Store.prototype.toJSON = function (ignoreAdditionalKeys) {
        if (ignoreAdditionalKeys === void 0) { ignoreAdditionalKeys = []; }
        if (!Array.isArray(ignoreAdditionalKeys)) {
            ignoreAdditionalKeys = ignoreAdditionalKeys.constructor === String ? [ignoreAdditionalKeys] : [];
        }
        var regexIgnorePrivate = /^_.+/;
        var simpleObject = toJS(this);
        var ignoreKeys = Object.keys(simpleObject)
            .filter(function (key) { return regexIgnorePrivate.test(key) || typeof simpleObject[key] === 'function'; })
            .concat(ignoreAdditionalKeys, 'logger');
        return merge.withoutKeys(ignoreKeys).merge({}, simpleObject);
    };
    return Store;
}(Store$1));

/**
 * MobX store that houses commonly used Expedia platform
 * data, such as `locale` or Abacus information.
 */
var ContextStore = /** @class */ (function (_super) {
    __extends(ContextStore, _super);
    /**
     * Constructs a new store from a `Context` object.
     *
     * @param context The raw platform context data.
     */
    function ContextStore(context, logger) {
        var state = __assign({}, context);
        if (Object.prototype.hasOwnProperty.call(state, 'localeOptions')) {
            delete state.localeOptions;
        }
        if (Object.prototype.hasOwnProperty.call(state, 'guid')) {
            delete state.guid;
        }
        return _super.call(this, state, logger) || this;
    }
    Object.defineProperty(ContextStore.prototype, "localeOptions", {
        get: function () {
            var _this = this;
            return this.site && this.site.supportedLocales
                ? this.site.supportedLocales.filter(function (locale) { return locale.locale !== _this.locale; })
                : [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContextStore.prototype, "guid", {
        get: function () {
            return this.deviceId;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * {@inheritDoc}
     */
    ContextStore.prototype.hydrate = function (data) {
        Object.assign(this, data);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ContextStore.prototype.toJSON = function (ignoreAdditionalKeys) {
        return _super.prototype.toJSON.call(this, 'remoteAddress');
    };
    __decorate([
        observable
    ], ContextStore.prototype, "locale", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "currency", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "site", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "deviceId", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "remoteAddress", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "userAgent", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "experiments", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "cookies", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "apiToken", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "recaptchaSiteKey", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "langId", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "localDateFormat", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "legal", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "links", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "user", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "deviceInformation", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "gdprInfo", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "securityContext", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "debugContext", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "analytics", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "localeInfo", void 0);
    __decorate([
        observable
    ], ContextStore.prototype, "privacyTrackingState", void 0);
    __decorate([
        computed
    ], ContextStore.prototype, "localeOptions", null);
    __decorate([
        computed
    ], ContextStore.prototype, "guid", null);
    __decorate([
        action
    ], ContextStore.prototype, "hydrate", null);
    return ContextStore;
}(Store));

/**
 * MobX store that houses page specific data, such
 * as SEO information or the page title.
 */
var PageStore = /** @class */ (function (_super) {
    __extends(PageStore, _super);
    /**
     * Constructs a new page store.
     *
     * @param title The HTML page title.
     * @param seo SEO specific information.
     * @param scripts JS scripts to include on page.
     */
    function PageStore(pageData, logger) {
        return _super.call(this, pageData, logger) || this;
    }
    Object.defineProperty(PageStore.prototype, "scripts", {
        get: function () {
            return this._scripts;
        },
        set: function (scripts) {
            this._scripts = scripts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageStore.prototype, "stylesheets", {
        get: function () {
            return this._stylesheets;
        },
        set: function (stylesheets) {
            this._stylesheets = stylesheets;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageStore.prototype, "inlineScripts", {
        get: function () {
            return this._inlineScripts;
        },
        set: function (inlineScripts) {
            this._inlineScripts = inlineScripts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageStore.prototype, "inlineStylesheets", {
        get: function () {
            return this._inlineStylesheets;
        },
        set: function (inlineStylesheets) {
            this._inlineStylesheets = inlineStylesheets;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * {@inheritDoc}
     */
    PageStore.prototype.hydrate = function (data) {
        Object.assign(this, data);
    };
    PageStore.prototype.fetch = function (meta, site, locale) {
        var _this = this;
        this.loading = true;
        var metadata = PageStore.getMeta(meta, site, locale);
        this.title = metadata.title;
        this.meta = metadata;
        return new Promise(function (resolve) {
            _this.loading = false;
            resolve(_this.toJSON());
        });
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PageStore.prototype.toJSON = function (ignoreAdditionalKeys) {
        return _super.prototype.toJSON.call(this, ['inlineStylesheets', 'inlineScripts']);
    };
    PageStore.getMeta = function (meta, site, locale) {
        var robots = meta.robots;
        var localeSpecificMeta = PageStore.localeSpecificMeta(meta, site.id, locale);
        var description = localeSpecificMeta.description;
        var title = localeSpecificMeta.title;
        var canonical = meta.canonical && meta.canonical(site);
        return {
            title: title,
            robots: robots,
            description: description,
            canonical: canonical,
        };
    };
    PageStore.localeSpecificMeta = function (meta, siteId, locale) {
        var siteMeta = meta[siteId];
        if (siteMeta) {
            var result = siteMeta[locale];
            if (!result) {
                result = siteMeta.default || {};
            }
            return result;
        }
        return {};
    };
    __decorate([
        observable
    ], PageStore.prototype, "title", void 0);
    __decorate([
        observable
    ], PageStore.prototype, "navigationId", void 0);
    __decorate([
        observable
    ], PageStore.prototype, "meta", void 0);
    __decorate([
        observable
    ], PageStore.prototype, "seo", void 0);
    __decorate([
        action
    ], PageStore.prototype, "hydrate", null);
    __decorate([
        action
    ], PageStore.prototype, "fetch", null);
    return PageStore;
}(Store));

var NO_ANALYTICS_DATA_WARN = new SystemEvent(SystemEventLevel.WARN, 'NO_ANALYTICS_DATA_WARN');
// public class
var AnalyticsStore = /** @class */ (function (_super) {
    __extends(AnalyticsStore, _super);
    function AnalyticsStore(state, logger) {
        if (state === void 0) { state = {}; }
        if (logger === void 0) { logger = NOOP_LOGGER; }
        return _super.call(this, state, logger) || this;
    }
    AnalyticsStore.prototype.hydrate = function (data) {
        Object.assign(this, data);
        if (this.analyticsData && this.analyticsData.length > 0) {
            this.publishForServerSideRendering(toJS(this.analyticsData));
        }
        else {
            if (this.logger) {
                this.logger.logEvent(NO_ANALYTICS_DATA_WARN, "Empty analytics data from hydration ('publishClientSidePayload' may have not been called during SSR)");
            }
        }
    };
    // public mobx methods
    AnalyticsStore.prototype.setPageNamespace = function (namespace) {
        if (typeof namespace !== 'string') {
            // Since we also send pageName to Omniture, we should make the namespace optional
            // If there is no namespace, let's default it to empty
            namespace = '';
        }
        this.namespace = namespace;
    };
    AnalyticsStore.prototype.publishClientSidePayload = function (clientSidePayloads) {
        var _a, _b;
        try {
            this.analyticsData = [];
            (_a = this.analyticsData).push.apply(_a, __spreadArray([], __read(clientSidePayloads), false));
            if (this.analyticsContext && this.analyticsContext.length !== 0) {
                this.overrideAnalyticsContextTraceId(clientSidePayloads);
                this.overrideAnalyticsContextPageUrlAndReferrerUrl(clientSidePayloads);
                (_b = this.analyticsData).push.apply(_b, __spreadArray([], __read(toJS(this.analyticsContext)), false));
            }
            PlatformAnalyticsStore.getPlatformAnalytics().publishClientSidePayload(toJS(this.analyticsData));
        }
        catch (err) {
            this.logger.logEvent(BERNIE_CORE_EVENTS.PUBLISH_ANALYTICS_ERROR, err);
        }
    };
    AnalyticsStore.prototype.markPageUsable = function (options) {
        PlatformAnalyticsStore.getPlatformAnalytics().markPageUsable(options);
    };
    AnalyticsStore.prototype.resetAnalyticsForNewPage = function () {
        PlatformAnalyticsStore.resetAnalyticsForNewPage();
    };
    // not an action as this does not update any mobx observables
    AnalyticsStore.prototype.trackEvent = function (rfrr, linkName, omnitureData, events, trackImmediate, uisPrimeMicroMessages) {
        try {
            trackEvent(this.namespace, rfrr, linkName, omnitureData, events, trackImmediate, this.logger, uisPrimeMicroMessages);
        }
        catch (err) {
            if (this.logger) {
                this.logger.logEvent(BERNIE_CORE_EVENTS.TRACK_EVENT_ERROR, err);
            }
        }
    };
    // wrapper method for click handlers
    AnalyticsStore.prototype.clickTracker = function (rfrr, linkName, events, callback, trackImmediate, uisPrimeMicroMessages) {
        // need to pass context of the store instance for the callback on the clicked element
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var context = this;
        return function () {
            AnalyticsStore.prototype.trackEvent.call(context, rfrr, linkName, context.omnitureData, events, trackImmediate, uisPrimeMicroMessages);
            // when callback is called, it should now be in the context of the caller
            if (typeof callback === 'function') {
                callback();
            }
        };
    };
    AnalyticsStore.prototype.setupTracker = function (id, description, trackImmediate, uisPrimeMicroMessages) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var context = this;
        if (id) {
            var callback = function (_id, _description) {
                return AnalyticsStore.prototype.trackEvent.call(context, _id, _description, context.omnitureData, null, trackImmediate, uisPrimeMicroMessages);
            };
            return {
                id: id,
                description: description,
                callback: callback,
            };
        }
    };
    AnalyticsStore.prototype.publishForServerSideRendering = function (analyticsData) {
        try {
            PlatformAnalyticsStore.getPlatformAnalytics().publishClientSidePayload(analyticsData);
        }
        catch (err) {
            this.logger.logEvent(BERNIE_CORE_EVENTS.PUBLISH_ANALYTICS_ERROR, err);
        }
    };
    AnalyticsStore.prototype.overrideAnalyticsContextTraceId = function (clientSidePayloads) {
        var firstTraceId = this.getFirstAvailableTraceIdFromPayloads(clientSidePayloads);
        if (firstTraceId) {
            this.analyticsContext.forEach(function (context) {
                context.traceId = firstTraceId;
                context.adobeMappedData.prop10 = firstTraceId;
            });
        }
    };
    AnalyticsStore.prototype.overrideAnalyticsContextPageUrlAndReferrerUrl = function (clientSidePayloads) {
        var _this = this;
        this.analyticsContext.forEach(function (context) {
            if (typeof window === 'object' && window.location && window.location.href) {
                var previousPageUrl = context.adobeMappedData.pageURL;
                context.adobeMappedData.pageURL = window.location.href;
                context.adobeMappedData.referrer = previousPageUrl;
            }
            else {
                var firstReferrerUrl = _this.getFirstAvailableReferrerUrlFromPayloads(clientSidePayloads);
                if (firstReferrerUrl) {
                    context.adobeMappedData.referrer = firstReferrerUrl;
                }
            }
        });
    };
    AnalyticsStore.prototype.getFirstAvailableTraceIdFromPayloads = function (clientSidePayloads) {
        if (clientSidePayloads && clientSidePayloads.length !== 0) {
            var traceIds = clientSidePayloads
                .filter(function (payload) { return payload.hasOwnProperty('traceId'); }) // eslint-disable-line no-prototype-builtins
                .map(function (payload) { return payload.traceId; });
            if (traceIds && traceIds.length !== 0) {
                return traceIds[0];
            }
        }
        return null;
    };
    AnalyticsStore.prototype.getFirstAvailableReferrerUrlFromPayloads = function (clientSidePayloads) {
        if (clientSidePayloads && clientSidePayloads.length !== 0) {
            var referrerUrls = clientSidePayloads
                .filter(function (payload) { return payload.adobeMappedData && payload.adobeMappedData.hasOwnProperty('referrer'); }) // eslint-disable-line no-prototype-builtins
                .map(function (payload) { return payload.adobeMappedData.referrer; });
            if (referrerUrls && referrerUrls.length !== 0) {
                return referrerUrls[0];
            }
        }
        return null;
    };
    AnalyticsStore.DEFAULTS = {
        namespace: '',
        omnitureData: {},
        requestId: '',
        analyticsData: [],
        analyticsContext: [],
    };
    __decorate([
        observable
    ], AnalyticsStore.prototype, "namespace", void 0);
    __decorate([
        observable
    ], AnalyticsStore.prototype, "omnitureData", void 0);
    __decorate([
        observable
    ], AnalyticsStore.prototype, "analyticsData", void 0);
    __decorate([
        observable
    ], AnalyticsStore.prototype, "analyticsContext", void 0);
    __decorate([
        action
    ], AnalyticsStore.prototype, "setPageNamespace", null);
    __decorate([
        action
    ], AnalyticsStore.prototype, "publishClientSidePayload", null);
    __decorate([
        action
    ], AnalyticsStore.prototype, "markPageUsable", null);
    __decorate([
        action
    ], AnalyticsStore.prototype, "resetAnalyticsForNewPage", null);
    return AnalyticsStore;
}(Store));

/**
 * Future home of Abacus related data. Currently just allows
 * `.logExperiment` to be injected.
 */
var ExperimentStore = /** @class */ (function (_super) {
    __extends(ExperimentStore, _super);
    /**
     * @param experimentLogger The experiment logger
     * @param logger The standard logger
     */
    function ExperimentStore(experimentContext, experimentLogger, logger) {
        if (logger === void 0) { logger = NOOP_LOGGER; }
        var _this = _super.call(this, {}, logger) || this;
        _this.experimentLogger = experimentLogger;
        _this.exposures = experimentContext && experimentContext.exposures;
        return _this;
    }
    /**
     * Using the Abacus public API, log a batch of exposures.
     * @param context The platform `Context`.
     * @param pageData The `PageData` store containing `pageName`.
     * @param exposure An Abacus exposure.
     */
    ExperimentStore.prototype.logExperiment = function (context, pageData, exposure) {
        this.experimentLogger(context, pageData, exposure);
    };
    /**
     * Does nothing for now.
     */
    ExperimentStore.prototype.hydrate = function (data) {
        this.exposures = data.exposures;
    };
    __decorate([
        observable
    ], ExperimentStore.prototype, "exposures", void 0);
    return ExperimentStore;
}(Store));

/**
 * Creates and "Hydrates" empty MobX stores on the client from serialized
 * state (`__PLUGIN_STATE__`).
 * @param data       The serialized stores (`__PLUGIN_STATE__.mobx.stores`) to use for hydration.
 * @param logger
 */
var hydrateCoreStores = function (data, logger) {
    // Must get context store first to get locale, and then set that locale
    var context = new ContextStore(data.context, logger);
    var stores = {
        analytics: new AnalyticsStore({}, logger),
        context: context,
        experiment: new ExperimentStore(data.experiment, getExperimentLogger({ logger: logger }), logger),
        page: new PageStore(data.page, logger),
    };
    // calling hydrate here to let analytics to publish server side collected data
    stores.analytics.hydrate(data.analytics);
    return stores;
};
/**
 * Creates and "Hydrates" empty MobX stores on the client from serialized
 * state (`__PLUGIN_STATE__`).
 * @param factories  The map of name to `StoreFactory` objects.
 * @param data       The raw (`__PLUGIN_STATE__`) to use for hydration.
 * @param l10n       Localization object for formatting text, dates, etc.
 * @param logger
 */
var hydrateAppStores = function (factories, data, bexApiContext, l10n) {
    var stores = {};
    if (typeof factories === 'function') {
        Object.assign(stores, __assign({}, factories({ bexApiContext: bexApiContext, l10n: l10n })));
    }
    else if (typeof factories === 'object') {
        Object.keys(factories).forEach(function (factoryKey) {
            var factory = factories[factoryKey];
            stores[factoryKey] = factory({ bexApiContext: bexApiContext, l10n: l10n });
        });
    }
    Object.keys(stores).forEach(function (storeKey) {
        stores[storeKey].hydrate(data[storeKey]);
    });
    return stores;
};

function MobxPlugin(options) {
    if (options === void 0) { options = {}; }
    var clientStores = options.clientStores;
    if (!clientStores && !clientStores.stores)
        throw new Error("clientStores not found in bernie.jsonc");
    return {
        name: 'mobx',
        onBrowserHydrateRenderContext: function (context, next) {
            var setAppData = context.setAppData, logger = context.logger, getAppData = context.getAppData;
            var appData = getAppData();
            var l10n = appData.l10n, stores = appData.stores;
            // hydrate serialized stores
            var coreStores = hydrateCoreStores(stores, logger);
            // Note: Consider removing/changing direct dependency on bexApiContext response here. Leaving it for backwards compat for now.
            var bexApiContext = getBexApiContext(coreStores.context);
            var appStores = hydrateAppStores(clientStores.stores, stores, bexApiContext, l10n);
            var hydratedStores = __assign(__assign({}, coreStores), appStores);
            setAppData({ stores: hydratedStores });
            return next(context);
        },
        onBrowserWrapRootElement: function (context, next) {
            var getAppData = context.getAppData, setRootElement = context.setRootElement;
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(Provider, __assign({}, getAppData().stores),
                React.createElement(RootElement, null, props.children))); }; });
            return next(context);
        },
    };
}

export { AnalyticsStore, ContextStore, ExperimentStore, PageStore, Store, MobxPlugin as default };
//# sourceMappingURL=browser.js.map
